import ArticleHighlightedCardUI from './ArticleHighlightedCardUI';
import { ArticleHighlightedCardProps } from './contracts';
import { useArticlesQuery } from '@data/articles/useArticlesQuery';
import { SkeletonLoader } from '@ui/common/components/SkeletonLoader';

export function ArticleHighlightedCard({
  queryParams,
  searchParams,
  variant,
  style,
  showAuthor = false,
  showDate = true,
  showImage = true,
  showTag = true,
  prioritize = false,
  imageObjectFit = 'cover',
  size,
}: ArticleHighlightedCardProps) {
  const {
    data,
    isLoading,
    error: articleError,
  } = useArticlesQuery({
    limit: 1,
    tags: (queryParams.tags || (searchParams?.tags as string)) ?? '',
    tagsMatchMode: queryParams.tagsMatchMode ?? undefined,
    sort: queryParams.sort,
    order: queryParams.order,
  });

  const article = data?.items[0];

  if (isLoading) {
    return (
      <div style={{ display: 'block', width: '100%', height: '100%' }}>
        <SkeletonLoader count={21} />
      </div>
    );
  }

  if (!data || !article || articleError) {
    return null;
  }

  return (
    <ArticleHighlightedCardUI
      article={article}
      variant={variant}
      style={style}
      showAuthor={showAuthor}
      showDate={showDate}
      showImage={showImage}
      showTag={showTag}
      prioritize={prioritize}
      imageObjectFit={imageObjectFit}
      size={size}
    />
  );
}
